function causa(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"A doença COVID-19 é causada por um vírus chamado SARS-CoV-2.",
						"title":"Quem causa a doença?",
						"image":"images/games/informs/causa/1.png",
					},
					{
						"text":"Ele faz parte de um grupo de vírus chamado coronavírus, que são conhecidos assim pela sua estrutura semelhante à de uma coroa solar.",
						"title":"Quem causa a doença?",
						"image":"images/games/informs/causa/1.png",
					},
					{
						"text":"O SARS-CoV-2 é esférico e tem aproximadamente 125 nm de tamanho.",
						"title":"Quem causa a doença?",
						"image":"images/games/informs/causa/1.png",
					},
					{
						"text":"Em sua superfície são encontradas as proteínas S (de spike), que são alongadas em formato de taco, o que atribui aos vírus a semelhança com o formato de uma coroa solar.",
						"title":"Quem causa a doença?",
						"image":"images/games/informs/causa/1.png",
					},
					{
						"text":"O SARS-CoV-2 utiliza sua proteína S para se ligar aos receptores ACE-2 (Angiotensin Converting Enzyme-2) , presentes na superfície de algumas células humanas.",
						"title":"Quem causa a doença?",
						"image":"images/games/informs/causa/1.png",
					},
					{
						"text":"A partir disso, o vírus insere seu material genético (RNA) dentro da célula, infectando-a.",
						"title":"Quem causa a doença?",
						"image":"images/games/informs/causa/1.png",
					},
					{
						"text":"Nos humanos, o SARS-CoV-2 infecta majoritariamente as células que recobrem o pulmão.",
						"title":"Quem causa a doença?",
						"image":"images/games/informs/causa/1.png",
					},
					{
						"text":"Porém, o receptor ACE2 também pode ser encontrada nas células dos rins, pâncreas, do coração e de outros órgãos, de modo que todos eles estão vulneráveis à infecção.",
						"title":"Quem causa a doença?",
						"image":"images/games/informs/causa/1.png",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/causa/1.png"
			}
		]
	};
}

export {causa};
